import React from "react";
import { Chart } from "react-google-charts";
import numbro from "numbro";
import { useSelector } from "react-redux";

const options = {
  sliceVisibilityThreshold: 0,
  backgroundColor: { fill: "transparent" },
  pieSliceBorderColor: "transparent",
  colors: ["#ff664e", "#1794ca", "#21e981", "#df30e5", "#1cdac4", "#7d4eff", "#ffbe4e", "#ca5317"],
  tooltip: {
    isHtml: true,
    trigger: "selection",
    textStyle: {
      fontSize: 14,
      bold: true,
      color: "#8791A0"
    }
  },
  chartArea: { left: 0, top: 20, width: "100%", height: "75%" },
  legend: {
    textStyle: {
      color: "#8791A0",
      fontSize: 16,
      bold: true
    },
    pagingTextStyle: {
      color: "#8fc447"
    },
    scrollArrows: {
      activeColor: "#8fc447"
    }
  }
};

const PieCharts = () => {
  const { pieCharts } = useSelector((state) => state.clientProfileModule);

  const pieChartsOptions = [
    {
      data: pieCharts?.visits_by_class?.data,
      formatters: pieCharts?.visits_by_class?.formatters,
      title: "Visits by Class"
    },
    {
      data: pieCharts?.visits_by_instructor?.data,
      formatters: pieCharts?.visits_by_instructor?.formatters,
      title: "Visits by Instructor"
    },
    {
      data: pieCharts?.visits_by_status?.data,
      formatters: pieCharts?.visits_by_status?.formatters,
      title: "Visits by Status"
    },
    {
      data: pieCharts?.revenue_by_product_name?.data,
      formatters: pieCharts?.revenue_by_product_name?.formatters,
      title: "Gross Revenue by Product Name"
    }
  ];

  return (
    <div data-testid="pie-charts-container" className="pie-charts-wrapper">
      {pieChartsOptions.map(({ data = [], title, formatters }) => {
        const chartData = data.sort((a, b) => {
          let num1 = numbro.unformat(a[1]);
          let num2 = numbro.unformat(b[1]);
          return num2 - num1;
        });

        return (
          <div data-testid="pie-chart" className="pie-chart" key={title}>
            <h5 className="pie-chart__title">{title}</h5>
            {chartData.length > 1 ? (
              <Chart
                chartType="PieChart"
                data={chartData}
                options={options}
                width="500px"
                formatters={formatters}
              />
            ) : (
              <p className="error">No data available</p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PieCharts;
